import correctImage from "../../assets/images/others/correct.png";
import progressImage from "../../assets/images/others/engineerAtWork.png";
import hourglassImage from "../../assets/images/others/hourglass.png";
import wrongImage from "../../assets/images/others/wrong.png";

const images = {
    "InProgress": progressImage,
    "Correct": correctImage,
    "Wrong": wrongImage,
    "HourGlass": hourglassImage
};

export default images;